// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"rY-z","sponsoredTooltipWrapper":"sY-z","sponsoredTooltip":"tY-z","newCard":"uY-z"};